<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Exportar Nómina</h4>
                <button ref="closeExportModal" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form theme-form">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="mb-3">
                                <select class="form-select" v-model="export_type">
                                    <option v-for="(type, index) in types" :key="index" :value="type.code">{{ type.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="exportPayroll">Exportar</button>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/employees'


export default {
    name: 'employee_export_modal',
    mixins: [],
    props: {
        
    },
    components: {
        
    },
    data(){
        return{
            showModal: true,
            types: [/*{code: 'general', name: 'Nómina General'}, */{code: 'detailed', name: 'Desglose de Nómina'}, {code: 'fiscal_payments', name: 'Pagos Fiscales (Layout)'}, {code: 'complementary_payments', name: 'Pagos Complementarios (Layout)'}],
            export_type: 'detailed',
            data: [],
            period: null
        }
    },
    methods: {
        loadData(data, period){
            this.data = data;
            this.period = period;
        },
        async exportPayroll() {
            let response = await ws.exportPayroll(this.data, this.period, this.export_type);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.closeModal();

                window.open(response.data, '_blank');
            }
            else{
                this.$toast.error(response.message);
            }
        },
        closeModal(){
            this.$refs.closeExportModal.click();
        }
    }
}
</script>